import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import NotFound from 'pages/NotFound'
import PurolatorYourWay from 'components/PurolatorYourWay'
import EmailToggle from 'components/EmailToggle'
import TrackingNumber from 'components/TrackingNumber'
import StatusBar from 'components/StatusBar'
import DeliveryDateAddrCorrection from 'components/DeliveryDateAddrCorrection'
import ViewPackagePreferences from 'components/ViewPackagePreferences'
import {
  getShippingInformation,
  updateTrackingDetails,
  updatePhotoPODImagesByPin,
} from 'store/shipping/shippingSlice'
import {
  selectIsLoading,
  selectPackageStatus,
  selectShippingInfo,
  selectIsUserVerified,
  selectIsLeadPinDelivered,
} from 'store/shipping/shippingSelectors'
import ImageBanner from 'components/ImageBanner'

import LoadingTruck from 'reusableComponents/LoadingTruck'
import ShowForDevice from 'reusableComponents/ShowForDevice'
import SessionTimeOutModal from 'components/SessionTimeOutModal'
import AdditionalInformation from 'components/AdditionalInformation'
import SetAndViewPreferences from 'components/SetAndViewPreferences'

import {
  Container,
  ShippingContainer,
  ShipmentDetailsContainer,
  ShippingInfoContainer,
} from './shipping.styles'

const pywBackendURL = process.env.REACT_APP_PYW_BACKEND_API

const ShippingInfo = () => {
  const dispatch = useDispatch()
  const { pin, lang } = useParams()
  const { i18n } = useTranslation()
  const { language } = i18n
  const prn = pywBackendURL

  const isUserVerified = useSelector(selectIsUserVerified)

  useEffect(() => {
    if (lang && i18n.language !== lang) {
      i18n.changeLanguage(lang)
    }

    dispatch(getShippingInformation(pin, language, prn))
  }, [dispatch, pin, language, prn, isUserVerified, lang, i18n])

  const isLoading = useSelector(selectIsLoading)
  const shippingInfo = useSelector(selectShippingInfo)
  const packageStatus = useSelector(selectPackageStatus)
  const isLeadPinDelivered = useSelector(selectIsLeadPinDelivered)

  if (isLoading) {
    return <LoadingTruck />
  }

  if (!shippingInfo) {
    return <NotFound />
  }
  const { vendor } = shippingInfo
  const onSelectPinHandler = (selectedPin) => {
    dispatch(updateTrackingDetails(selectedPin))
    dispatch(updatePhotoPODImagesByPin(selectedPin))
  }
  return (
    <div>
      <ImageBanner shipmentStatus={packageStatus} vendor={vendor.name} />
      <Container>
        <PurolatorYourWay />
        <ShipmentDetailsContainer>
          <ShippingContainer>
            {!isLeadPinDelivered &&
              !shippingInfo.isRecipientProfile &&
              !shippingInfo.isEmailAddressAvailable && <EmailToggle />}
            <TrackingNumber onSelectPinHandler={onSelectPinHandler} />
            <StatusBar />
            <ShippingInfoContainer>
              <DeliveryDateAddrCorrection />
              {isLeadPinDelivered ? <ViewPackagePreferences /> : <SetAndViewPreferences />}
              <ShowForDevice showOnlyFor={['phone', 'tablet']}>
                <AdditionalInformation device="mobOrTablet" />
              </ShowForDevice>
              <ShowForDevice showOnlyFor={['desktop']}>
                <AdditionalInformation device="desktop" onSelectPinHandler={onSelectPinHandler} />
              </ShowForDevice>
            </ShippingInfoContainer>
          </ShippingContainer>
        </ShipmentDetailsContainer>
        <SessionTimeOutModal sessionActive={isUserVerified} />
      </Container>
    </div>
  )
}

export default ShippingInfo
